import React, {Component, useEffect, useState} from "react";
import {Form, Loader, Message} from 'semantic-ui-react'
import moment from "moment";
import {useNavigate} from "react-router";
import {SuccessMessage} from "../_core/SuccessMessage";

export default function ZohoGrabberCreditNote(props) {
    const [data, setData] = useState({
            grabber: '',
            date_start: moment().startOf('month').format('YYYY-MM-DD'),
            date_end: moment().endOf('month').format('YYYY-MM-DD'),
            loading: false
        })
    ;
    const navigate = useNavigate()

    const handleInputChange = (event) => {
        const target = event.target;
        const value = target.type === 'checkbox' ? target.checked : target.value;
        const name = target.name;

        setData({...data, [name]: value});
    }

    const handleSubmit = async () => {
        const url = API_URL + `/api/private/tanker/v1/zoho/grabber/creditnotes/fetch?date_start=${data.date_start}&date_end=${data.date_end}`

        setData({...data, loading: true, grabber: ''});

        const token = sessionStorage.token
        if (!(token && token.length > 0)) navigate('/login')

        fetch(url, {headers: new Headers({'Authorization': `Bearer ${token}`})})
            .then(function (response) {
                if (response.status >= 400) {
                    throw new Error("Bad response from server");
                }
                return response.json();
            })
            .then(function (data) {
                setData({...data, grabber: data, loading: false});
            });
    }

    useEffect(() => {
        document.title = 'Grab credit note'

        const token = sessionStorage.token
        if (!(token && token.length > 0)) {
            navigate("/login")
        }
    }, [])

    const loading = data.loading;
    const message = data.grabber.message;

    return (
        <div>
            <h2>Credit Notes </h2>
            <p>Fetches the creditnotes from Zoho within date_start and date_end</p>
            <Form>
                <Form.Group widths='equal'>
                    <Form.Input label="date_start" name="date_start" placeholder="2017-01-01"
                                value={data.date_start} onChange={handleInputChange}/>
                    <Form.Input label="date_end" name="date_end" placeholder="2017-01-31"
                                value={data.date_end} onChange={handleInputChange}/>
                </Form.Group>
                <Form.Button onClick={handleSubmit}>Submit</Form.Button>
            </Form>
            {loading ? <Loader active inline='centered'></Loader> : ''}
            {typeof message !== 'undefined' ? <SuccessMessage header="Success" message={message}/> : ''}
        </div>
    )
}


